module.exports = __webpack_public_path__ + "img/peacejam-banner-cropped.96c508c4.jpg";